import Expense from "./Expense";

export default Expense;
